import { Button } from "@svea/design-system-components-react";
import {
	FormWithTracking,
	isRequired,
	P,
	Stack,
	TextField,
	trim,
	validateSsn,
} from "@sveabank/cc-common";
import type { GuarantorLookup } from "../../../types/guarantor";

type Props = {
	handleGetName: (values: GuarantorLookup) => void;
	descriptionText: string;
	labelText: string;
	buttonText: string;
};

const GuarantorLookupForm = ({ handleGetName, descriptionText, buttonText, labelText }: Props) => (
	<Stack gap={4}>
		<P>{descriptionText}</P>
		<FormWithTracking<GuarantorLookup>
			onSubmit={handleGetName}
			matomoInstance={window.Matomo}
			render={({ handleSubmit, submitting }) => (
				<form onSubmit={handleSubmit} name="guarantorLookupForm">
					<Stack direction="row" align="start" gap={4}>
						<TextField
							label={labelText}
							type="text"
							name="ssn"
							fullWidth
							parse={trim}
							validators={[isRequired, validateSsn]}
						/>

						<Button variant="secondary" type="submit" isDisabled={submitting}>
							{buttonText}
						</Button>
					</Stack>
				</form>
			)}
		/>
	</Stack>
);

export default GuarantorLookupForm;
